module.exports = __webpack_public_path__ + "img/third_wave_bottom.abb56b62.svg";